import React from 'react';
import { Carousel, Table } from 'react-bootstrap';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';

const OverviewTableMobile = props => { 
    const utilities = [
        { key: 'water', label: 'Water', unit: 'm³' },
        { key: 'electricity', label: 'Electricity', unit: 'kWh' },
        { key: 'gas', label: 'Gas', unit: 'm³' },
        { key: 'ghg', label: 'GHG', unit: 'MT CO₂e', divisor: 1000 },
        { key: 'cost', label: 'Cost', prefix: '$' },
    ];

    const navigate = useNavigate();

    const formatVal = (val, util) => {
        if (val == null) return 'N/A';
        const num = util.divisor ? val / util.divisor : val;
        return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    return (
        <>
        <Carousel indicators={true} interval={null}>
            {utilities.map(util => (
                <Carousel.Item key={util.key}>
                    
                    <Table style={{ margin: 'auto', width: '98%' }}>
                        
                        <thead>
                            <tr className="btn-brand-bg" style={{ color: 'white' }}>
                                <th>Site</th>
                                <th colSpan={3} style={{ textAlign: 'center' }}>
                                    {util.label}
                                </th>
                            </tr>
                            <tr style={{ backgroundColor: 'rgb(0,177,168)', color: 'white' }}>
                                <th></th>
                                <th style={{ textAlign: 'center' }}>Last Month</th>
                                <th style={{ textAlign: 'center' }}>This Month</th>
                                <th style={{ textAlign: 'center' }}>Increase</th>
                            </tr>
                        </thead>

                        <tbody>
                            {props.isLoading && (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'center' }}>
                                        <CircularProgress />
                                    </td>
                                </tr>
                            )}

                           
                            {props.tableData.map((row, i) => {
                                const value = row[util.key];

                                return (
                                    <tr key={i}>
                                    
                                        <td style={{ fontSize: '0.95rem' }}>
                                            <span
                                                style={{ color: 'darkblue', cursor: 'pointer' }}
                                                onClick={() => navigate(`/site/${row.siteID}`)}
                                            >
                                                {row.siteName}
                                            </span>
                                        </td>

                                        
                                        <td style={{ textAlign: 'center', fontSize: '0.95rem' }}>
                                            {util.prefix || ''}
                                            {formatVal(value?.prev, util)}
                                            {util.unit && util.key !== 'cost' && (
                                                <span style={{ fontSize: '0.8rem', color: 'grey' }}>
                                                    {' '} {util.unit}
                                                </span>
                                            )}
                                        </td>

                                        
                                        <td style={{ textAlign: 'center', fontSize: '0.95rem' }}>
                                            {util.prefix || ''}
                                            {formatVal(value?.curr, util)}
                                            {util.unit && util.key !== 'cost' && (
                                                <span style={{ fontSize: '0.8rem', color: 'grey' }}>
                                                    {' '} {util.unit}
                                                </span>
                                            )}
                                        </td>

                                        
                                        <td style={{ textAlign: 'center', fontSize: '0.95rem' }}>
                                            {value?.pctChange == null ? (
                                                <span style={{ color: 'grey' }}>N/A</span>
                                            ) : (
                                                <span style={{ color: value.pctChange > 0 ? 'red' : 'green' }}>
                                                    {(Math.round(value.pctChange * 1000) / 10).toFixed(1)}%
                                                </span>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}

                            
                            {props.totals && (
                                <tr>
                                    <td style={{ fontWeight: 'bold' }}>Total</td>

                                    <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        {util.prefix || ''}
                                        {formatVal(props.totals[util.key]?.prev, util)}
                                    </td>

                                    <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        {util.prefix || ''}
                                        {formatVal(props.totals[util.key]?.curr, util)}
                                    </td>

                                    <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        {props.totals[util.key]?.pctChange == null ? (
                                            <span style={{ color: 'grey' }}>N/A</span>
                                        ) : (
                                            <span style={{ color: props.totals[util.key].pctChange > 0 ? 'red' : 'green' }}>
                                                {(Math.round(props.totals[util.key].pctChange * 1000) / 10).toFixed(1)}%
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                    
                </Carousel.Item>
            ))}
        </Carousel>
        <div style={{ textAlign: 'center', marginBottom: '6px' }}>
            <div style={{ fontSize: '0.85rem', color: 'grey' }}>
                    ← Swipe to see other utilities →
            </div>
        </div>
        </>
        
    );
};

export default OverviewTableMobile;
